import { JSX } from 'preact';
import { useRef } from 'preact/hooks';
import { HiddenAccessible } from '../UNSAFE_HiddenAccessible';

type IntrinsicProps = Pick<JSX.HTMLAttributes<HTMLDivElement>, 'children'>;

type SkipLinkProps = IntrinsicProps & {
  message?: string;
  callback?: () => void;
};

export function PopupSkipLink({ message, callback }: SkipLinkProps) {
  const hiddenAccessibleRef = useRef<HTMLDivElement | null>(null);

  const handleKey = (event: KeyboardEvent) => {
    // Prevent click generated from an "enter" key press by eating the event.
    // This could only happen in some kind of simulator as this skip link is only used on the iOS platform.
    if (event.code === 'Enter') {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  return (
    <div ref={hiddenAccessibleRef}>
      <HiddenAccessible>
        <a
          onClick={callback}
          tabIndex={-1}
          href="#"
          role="button"
          onKeyDown={handleKey}
          onKeyUp={handleKey}
          onKeyPress={handleKey}>
          {message}
        </a>
      </HiddenAccessible>
    </div>
  );
}
